import React from "react";
import type { ConversationListItem } from "@/api";
import { useT, type TFunc } from "../i18n";

/** Display facts identify a candidate; they never establish customer or recipient authority. */
export function conversationCustomerLabel(row: ConversationListItem, t: TFunc): string {
  return row.contact_form_source
    ? row.customer_name || row.confirmed_customer_email || t("ws.form.unresolved")
    : row.from || t("inbox.unknownSender");
}

export function FormCustomerSource({ row }: { row: ConversationListItem }) {
  const t = useT();
  if (!row.contact_form_source) return null;
  const state = `${t(row.confirmed_customer_email ? "ws.form.confirmed" : "ws.form.unconfirmed")}${
    row.confirmed_customer_email ? ` · ${row.confirmed_customer_email}` : ""}`;
  const source = `${t("ws.form.source")}: ${row.source_address || t("inbox.unknownSender")}`;
  // #2178: the worklist shows this as one cut line, so the whole text is also the title.
  return (
    <span className="form-customer-source" title={`${state} · ${source}`}>
      <span>{state}</span>
      <span>{source}</span>
    </span>
  );
}
